/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import trillionGreenUrl from '../../../assets/gems/trillion_green.svg?inline';
export function TrillionGreen({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: trillionGreenUrl,
        alt: "TrillionGreenImage"
    });
}
